import React, { useEffect, useRef } from 'react';

const slideIndexFromAriaLabel = ariaLabel => {
  const match = ariaLabel?.match(/(\d+)$/);
  return match ? Number(match[1]) - 1 : null;
};

export const localizeImageGalleryAriaLabels = (
  galleryRoot,
  slideLabels,
  thumbnailNavigationLabel
) => {
  if (!galleryRoot || slideLabels.length === 0) {
    return;
  }

  const controls = galleryRoot.querySelectorAll('.image-gallery-slide, .image-gallery-thumbnail');
  controls.forEach((control, position) => {
    const storedIndexAttribute = control.getAttribute('data-rematch-slide-index');
    const storedIndex = Number(storedIndexAttribute);
    const hasStoredIndex =
      storedIndexAttribute !== null && Number.isInteger(storedIndex) && storedIndex >= 0;
    const parsedIndex = slideIndexFromAriaLabel(control.getAttribute('aria-label'));
    const slideIndex = hasStoredIndex ? storedIndex : parsedIndex ?? position % slideLabels.length;
    const localizedLabel = slideLabels[slideIndex];

    if (localizedLabel) {
      control.setAttribute('data-rematch-slide-index', String(slideIndex));
      control.setAttribute('aria-label', localizedLabel);
    }
  });

  const thumbnailNavigation = galleryRoot.querySelector('.image-gallery-thumbnails-container');
  if (thumbnailNavigation) {
    thumbnailNavigation.setAttribute('aria-label', thumbnailNavigationLabel);
  }
};

const ImageGalleryAriaLabels = props => {
  const { slideLabels, thumbnailNavigationLabel } = props;
  const anchorRef = useRef(null);

  useEffect(() => {
    const galleryRoot = anchorRef.current?.closest('.image-gallery');
    localizeImageGalleryAriaLabels(galleryRoot, slideLabels, thumbnailNavigationLabel);
  });

  return <span ref={anchorRef} hidden />;
};

export default ImageGalleryAriaLabels;
